var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src,"reverse-transition":"fade-transition","transition":"fade-transition"}},[_c('h2',[_vm._v(_vm._s(item.src))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }